var _style, _path, _polygon, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfraWhiteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "15 57 749 186",
    style: {
      enableBackground: "new 0 0 792 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFF;}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.8,150.5V150c0-51.7,41.8-92.3,98.3-92.3c38.1,0,62.6,15.2,79.1,37l-38.9,28.7 c-10.7-12.7-22.9-20.8-40.8-20.8c-26.1,0-44.5,21-44.5,46.9v0.5c0,26.6,18.4,47.4,44.5,47.4c19.5,0,30.9-8.6,42.1-21.6l38.9,26.4 c-17.6,23.1-41.3,40.1-82.6,40.1C57.6,242.3,14.8,203.5,14.8,150.5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "209.7,61.2 358.9,61.2 358.9,104.3 261.4,104.3 261.4,134.5 349.6,134.5 349.6,175.4 261.4,175.4  261.4,238.8 209.7,238.8 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.7,238.8L375.3,61.2v177.5h55.4V238.8z M508.5,174.1c19.7-10,32.3-27.1,32.3-51.8v-0.5 c0-17.5-5.6-31.2-16.5-41.3c-12.5-12.2-32.2-19.3-60.7-19.3h-88.1l51.7,74v-31.4H461c17.3,0,28,7.1,28,21v0.5 c0,12.9-10.1,21.1-27.7,21.1h-26.2l64.5,92.3h55.1L508.5,174.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M669.9,60h-49.8l-69.3,156.2l11.9,16.8l4.2,5.9h28.2l13.3-31.7h71.9l13.6,31.7h55.4L669.9,60z M623.6,168.8 l21-50.5l20.8,50.5H623.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfraWhiteLogo);
export default __webpack_public_path__ + "static/media/CFRA White Logo.01dbe89659d4cb67b616f795436888ad.svg";
export { ForwardRef as ReactComponent };